import styled from 'styled-components';
import { fontSize_XS } from '../customFonts';

export const StyledLegendWrapper = styled.div`
    .item {
        margin-bottom: 12px;
    }

    p {
        color: #45445c;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        padding-right: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const ChartTooltipStyles = styled.div`
    background-color: #f9fafb;
    border-radius: 8px;
    display: flex;
    padding: 12px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 10px 15px -3px rgba(23, 23, 28, 0.1), 0px 4px 6px -2px rgba(23, 23, 28, 0.05);

    .label {
        color: #111827;
        font-weight: 600;
        line-height: 16px;
    }

    p {
        color: #45445c;
        font-weight: 400;
        line-height: normal;
        margin: 0;
    }

    .label,
    p {
        ${fontSize_XS};
        font-style: normal;
    }
`;
